import moment from "moment";

export class Date extends React.Component {

    render() {

        return <React.Fragment>{moment(this.props.date).format("DD/MM/YYYY h:mma")}</React.Fragment>

    }

}